import styles from './Tables.module.scss'
import { useAppContext } from '../../hooks/useAppContext'
import { Table } from './Table'

export const Calculations = () => {
    const { tableValues } = useAppContext()
    return (
        <section className={styles.containier} >
            <h5 className={styles.heading}>Calculations</h5>
            <Table renderDataForTable={tableValues} />
        </section>
    )
}
